module.exports = __webpack_public_path__ + "static/img/z.5a29b806.png";